/**
 * @generated SignedSource<<c21f40f6831ed9c795c34d10711d6d05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedYMAL_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedMobileRelatedItem_user" | "SharedRelatedItemsWrapper_user" | "SharedRespRelatedItem_user">;
  readonly " $fragmentType": "SharedYMAL_user";
};
export type SharedYMAL_user$key = {
  readonly " $data"?: SharedYMAL_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedYMAL_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedYMAL_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedItemsWrapper_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedMobileRelatedItem_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespRelatedItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "baf7738c36f81e1dd5c4ca7a1365784e";

export default node;
